import React, { Component } from 'react';
import styled from 'styled-components';
// import mediaWidth from '../../../utils/mediaWidth/mediaWidth';

import BlueCircle from '../../../common/BlueCircle';

import animationParams from './animations';
import animationStates from './animationStates';
import screenData from '../../PhaserComponent/data/screenData';
import pointsData from '../../PhaserComponent/data/pointsData';
import getScreenSize from '../../PhaserComponent/getSreenSize';

class BluePointsBlock extends Component {
    render() {
        const {
            className,
            animationState,
            // handleOpenPopUp,
            // handleChangePage,
            // scrollToForm,
        } = this.props;

        // console.log(animationState);

        const animation = animationParams[animationState];

        return (
            animationState === animationStates.NONE ? (
                <Root className={className}>
                    {
                        pointsData.map(({ id, ...data }) => (
                            <StyledBlueCircle
                                key={id}
                                params={data[getScreenSize()]}
                            />
                        ))
                    }
                </Root>
            ) : (
                <Root className={className}>
                    {
                        pointsData.map(({ id, ...data }) => (
                            <StyledAnimationBlueCircle
                                key={id}
                                params={data[getScreenSize()]}
                                animationName={animation.name[id]}
                                duration={animation.duration}
                                timingFunction={animation.timingFunction}
                            />
                        ))
                    }
                </Root>
            )
        );
    }
}

const StyledBlueCircle = styled(BlueCircle)`
    position: fixed;
    left: ${({ params: { x } }) => `${
        x.finish < screenData[getScreenSize()].width / 2 ? x.finish
            : window.innerWidth - (screenData[getScreenSize()].width - x.finish)
    }px`};
    top: ${({ params: { y } }) => `${
        y.finish < screenData[getScreenSize()].height / 2 ? y.finish
            : window.innerHeight - (screenData[getScreenSize()].height - y.finish)
    }px`};

    pointer-events: none;
`;

const StyledAnimationBlueCircle = styled(BlueCircle)`
    position: fixed;
    left: ${({ params: { x } }) => `${((window.innerWidth - screenData[getScreenSize()].width) / 2) + x.start}px`};
    top: ${({ params: { y } }) => `${((window.innerHeight - screenData[getScreenSize()].width) / 2) + y.start}px`};

    pointer-events: none;

    opacity: 0;

    animation-name: ${({ animationName }) => animationName};
    animation-duration: ${({ duration }) => duration};
    animation-timing-function: ${({ timingFunction }) => timingFunction};
    animation-fill-mode: forwards;

    transform: ${({ params: { diameter: { start, finish } } }) => `scale(${Math.round((100 * start) / finish) / 100})`};
    transform-origin: top left;
`;

const Root = styled.div``;

export default BluePointsBlock;
